import {FRANCE_LANGUAGE_CONFIG} from './france.config';
import {LanguageCountryConfig} from './language-country.config';
import {UNITED_KINGDOM_LANGUAGE_CONFIG} from './united-kingdom.config';

export const DEFAULT_LANGUAGE_CODE = FRANCE_LANGUAGE_CONFIG.code;

export const LANGUAGE_COUNTRY_CONFIGS: LanguageCountryConfig[] = [
  FRANCE_LANGUAGE_CONFIG,
  UNITED_KINGDOM_LANGUAGE_CONFIG
];
